/**
 *
 * KzamMultiselect
 *
 */
(function ($) {
    var pluginName = 'KzamMultiselect';

    function Plugin(element, options) {
        //select d'origine
        var $select = $(element);

        //enveloppe de tout le composant
        var $wrapper;

        //screen overlay pour le mobil
        var $screenOverlay;

        //select affiché
        var $selectOut;

        //div contenant tout le composant
        var $panel;

        //div contenant la liste des options
        var $content;

        //div contenant un div de la liste des options (utile pour certains plugins de scroll)
        var $wrapperContent;

        //input hidden utilisé pour les valeurs
        var $input;

        //toutes les cases à cocher (sauf le bouton checkall et les boutons checks group)
        var $allCheckboxes;

        //toutes les cases à cocher permettant de cocher les cases du groupes (sans valeur)
        var $btnCheckGroup;

        //bouton check ALL
        var $btnCheckAll;

        var datas = [];

        //Enveloppe du bouton submit
        var $buttonsWrapper;

        //bouton submit
        var $btnSubmit;
        
        let $btnClose;

        let $wrapperLoading;

        //callbacks
        var funcOnOpen=function(){},funcOnClose=function(){},funcOnSubmit=function(){},funcOnRefresh=function(){};
        let funcOnChange = () => {};

        //liste des options
        options = {...{}, ...$.fn[pluginName].defaults, ...options};

        /**
         * Constructeur / initialisation du plugin
         */
        function init() {
            if (!$select.is("select[multiple]")) {
                throw new Error("[ " + pluginName + " ] Impossible d'initialiser le plugin sur un élément qui n'est pas de type select multiple");
            }
            if (typeof $select.attr("name") === typeof undefined || $select.attr("name") === false) {
                throw new Error("[ " + pluginName + " ] Impossible d'initialiser le plugin sur un élément sans name");
            }
            if (typeof $select.attr("id") === typeof undefined || $select.attr("id") === false) {
                throw new Error("[ " + pluginName + " ] Impossible d'initialiser le plugin sur un élément sans id");
            }
            refresh();
        }

        /**
         *  Lecture des parametres passé : en option, en data-kzam-multiselect-PARAM, ou en data-kzam-multiselect-options (JSON)
         */
        function readParam() {
            //lecture des options sur le DOM
            if (typeof $select.attr("data-kzam-multiselect-title") !== typeof undefined && $select.attr("data-kzam-multiselect-title") !== false) {
                options["title"] = $select.attr("data-kzam-multiselect-title") ;
            }
            if (typeof $select.attr("data-kzam-multiselect-display_count_in_title") !== typeof undefined && $select.attr("data-kzam-multiselect-display_count_in_title") !== false) {
                options["display_count_in_title"] = $select.attr("data-kzam-multiselect-display_count_in_title") ;
            }
            if (typeof $select.attr("data-kzam-multiselect-checkall") !== typeof undefined && $select.attr("data-kzam-multiselect-checkall") !== false) {
                options["checkall"] = ( $select.attr("data-kzam-multiselect-checkall") === 'true');
            }
            if (typeof $select.attr("data-kzam-multiselect-checkall_label") !== typeof undefined && $select.attr("data-kzam-multiselect-checkall_label") !== false) {
                options["checkall_label"] = $select.attr("data-kzam-multiselect-checkall_label");
            }
            if (typeof $select.attr("data-kzam-multiselect-merge_output") !== typeof undefined && $select.attr("data-kzam-multiselect-merge_output") !== false) {
                options["merge_output"] = ( $select.attr("data-kzam-multiselect-merge_output") === 'true');
            }
            if (typeof $select.attr("data-kzam-multiselect-submit") !== typeof undefined && $select.attr("data-kzam-multiselect-submit") !== false) {
                options["submit"] = ( $select.attr("data-kzam-multiselect-submit") === 'true');
            }
            if (typeof $select.attr("data-submit_label") !== typeof undefined && $select.attr("data-submit_label") !== false) {
                options["submit_label"] = $select.attr("data-kzam-multiselect-submit_label");
            }
            if (typeof $select.attr("data-display_close_button") !== typeof undefined && $select.attr("data-display_close_button") !== false) {
                options["display_close_button"] = $select.attr("data-kzam-multiselect-display_close_button");
            }
            if (typeof $select.attr("data-close_button_label") !== typeof undefined && $select.attr("data-close_button_label") !== false) {
                options["close_button_label"] = $select.attr("data-kzam-multiselect-close_button_label");
            }
            if (typeof $select.attr("data-kzam-multiselect-height") !== typeof undefined && $select.attr("data-kzam-multiselect-height") !== false) {
                options["height"] = $select.attr("data-kzam-multiselect-height");
            }
            if (typeof $select.attr("data-kzam-multiselect-scrollbar_width") !== typeof undefined && $select.attr("data-kzam-multiselect-scrollbar_width") !== false) {
                options["scrollbar_width"] = $select.attr("data-scrollbar_width");
            }
            if (typeof $select.attr("data-kzam-multiselect-checkbox_width") !== typeof undefined && $select.attr("data-kzam-multiselect-checkbox_width") !== false) {
                options["checkbox_width"] = $select.attr("data-kzam-multiselect-checkbox_width");
            }
            if (typeof $select.attr("data-kzam-multiselect-class_content_wrapper") !== typeof undefined && $select.attr("data-kzam-multiselect-class_content_wrapper") !== false) {
                options["class_content_wrapper"] = $select.data("kzam-multiselect-class_content_wrapper");
            }
            if (typeof $select.attr("data-kzam-multiselect-class_content") !== typeof undefined && $select.attr("data-kzam-multiselect-class_content") !== false) {
                options["class_content"] = $select.data("kzam-multiselect-class_content");
            }
            if (typeof $select.attr("data-kzam-multiselect-submit_button_class") !== typeof undefined && $select.attr("data-kzam-multiselect-submit_button_class") !== false) {
                options["submit_button_class"] = $select.data("kzam-multiselect-submit_button_class");
            }
            if (typeof $select.attr("data-kzam-multiselect-close_button_class") !== typeof undefined && $select.attr("data-kzam-multiselect-close_button_class") !== false) {
                options["close_button_class"] = $select.data("kzam-multiselect-close_button_class");
            }




            //lecture de la balise JSON
            if (typeof $select.data("kzam-multiselect-options") !== typeof undefined && $select.data("kzam-multiselect-options") !== false) {

                let optionsJSON = $select.data("kzam-multiselect-options");

                options = {...{}, ...options, ...optionsJSON};
            }


        }

        /**
         * Parse le DOM et génére le tableau de données utile à la construction du multi select
         */
        function parseData() {
            datas = [];
            var $opt;
            var $optChild;
            var optChilds = [];
            var value = "";
            $select.children().each(function () {
                $opt = $(this);
                if ($(this).is("optgroup")) {
                    optChilds = [];
                    $(this).children().each(function () {
                        $optChild = $(this);
                        value = $optChild.attr("value");
                        if (typeof value === typeof undefined || value === false) {
                            value = "__(EMPTY)__";
                        }
                        // console.log($optChild);
                        optChilds.push({
                            "label": $optChild.text(),
                            "value": value,
                            "child": [],
                            "css": $optChild.data("css"),
                            "selected": $optChild.prop("selected"),
                            "disabled": $optChild.prop("disabled")
                        });
                    });
                    value = $opt.data("value");
                    if (typeof value === typeof undefined || value === false) {
                        value = "__(EMPTY)__";
                    }

                    datas.push({
                        "label": $opt.attr("label"),
                        "value": value,
                        "child": optChilds,
                        "css": $opt.data("css"),
                        "selected": $opt.data("selected"),
                        "disabled": $opt.prop("disabled")

                    });
                } else {
                    value = $opt.attr("value");
                    if (typeof value === typeof undefined || value === false) {
                        value = "__(EMPTY)__";
                    }

                    datas.push({
                        "label": $opt.text(),
                        "value": value,
                        "child": [],
                        "css": $opt.data("css"),
                        "selected": $opt.prop("selected"),
                        "disabled": $opt.prop("disabled")
                    });
                }

            });
        }

        /**
         * Restaure le multiselect dans son état initial (sans le composant)
         */
        function restore() {

            $select.removeClass("kzam_multiselect__select_hidden");
            if( typeof($select.data("kzam_multiselect-name")) !== typeof undefined ){
                $select.attr("name", $select.data("kzam_multiselect-name"));
            }
            if (typeof($wrapper) !== typeof undefined) {
                $wrapper.remove();
            }
        }


        /**
         * Calcul et affiche l'etat des checkgroup en fonction des checkbox enfants
         * @param idInput
         * @param nameInput
         */
        function refreshCheckGroupState(idInput, nameInput) {
            //gestion de la case check du group

            var $allCheckBox = $wrapper.find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']");

            $allCheckBox.each(function (e, i) {
                var $e = $(this);

                var $btnCheckGroupParent = $e.parent().parent().parent().find("input[type='checkbox'][name='" + nameInput + "_group_check']");
                var $allCheckOfGroup = $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']");
                var $allCheckOfGroupChecked = $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']:checked");
                if ($btnCheckGroupParent.length > 0) {
                    if ($allCheckOfGroup.length !== $allCheckOfGroupChecked.length && $allCheckOfGroupChecked.length > 0) {
                        $btnCheckGroupParent.prop("checked", true);
                        $btnCheckGroupParent.prop("indeterminate", true);
                    } else {
                        $btnCheckGroupParent.prop("indeterminate", false);
                        if ($allCheckOfGroupChecked.length === 0) {
                            $btnCheckGroupParent.prop("checked", false);
                        } else {
                            $btnCheckGroupParent.prop("checked", true);
                        }
                    }
                }

            });

        }

        /**
         * Calcul et affiche l'etat de la cas checkall en fonction des checkbox enfants
         * @param idInput
         */
        function refreshCheckAllState(idInput) {
            //gestion de la case check ALL
            if ($btnCheckAll.length > 0) {
                //verifie l'etat de la case checkall
                var $allCheckboxesChecked = $wrapper.find("input[type='checkbox'][id!='" + idInput + "_all_check']:checked");
                if ($allCheckboxesChecked.length !== $allCheckboxes.length && $allCheckboxesChecked.length > 0) {
                    $btnCheckAll.prop("checked", true);
                    $btnCheckAll.prop("indeterminate", true);
                } else {
                    $btnCheckAll.prop("indeterminate", false);
                    if ($allCheckboxesChecked.length === 0) {
                        $btnCheckAll.prop("checked", false);
                    } else {
                        $btnCheckAll.prop("checked", true);
                    }
                }
            }

        }

        function refreshTitle()
        {
            $selectOut.find("option").text( getTitle() );
        }

        function getTitle()
        {
            let title = option("title");
            if( option("display_count_in_title") === true )
            {
                // let checkedCount = $wrapper.find("input[type='checkbox']:checked").length;
                let selected = getValue();
                title += " ("+ selected.length +"/"+ datas.length +")";
            }
            return title;
        }

        function getValue()
        {
            return( $input.val().length > 0 ? JSON.parse($input.val()) : [] );
        }

        function getValuesMap()
        {
            let valuesMap = {};
            //$allCheckboxes = $wrapper.find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']")
            $allCheckboxes.each((i, e) =>
            {
               let $chk = $(e);
               valuesMap[$chk.val()] = $chk.prop("checked");
            });
            return valuesMap;
        }

        function getUncheckedValues()
        {
            let uncheckedValues = [];
            $allCheckboxes.each((i, e) =>
            {
                let $chk = $(e);
                if( $chk.prop("checked") !== true )
                {
                    uncheckedValues.push($chk.val());
                }
            });
            return uncheckedValues;
        }

        /**
         * Affiche le composant
         */
        function refresh() {
            if( typeof($select.data("kzam_multiselect-name")) !== typeof undefined ){
                $select.attr("name", $select.data("kzam_multiselect-name"));
            }
            if (typeof($wrapper) !== typeof undefined) {
                $wrapper.remove();
            }
            readParam();
            parseData();

            //select affiché
            $selectOut = $("<select>");
            $input = $("<input>").attr("type", "hidden");
            $panel = $("<div>");
            $wrapper = $("<div>");
            $content = $("<div>");
            $wrapperContent = $("<div>");
            $buttonsWrapper = $("<div>");
            $btnSubmit = $("<button>");
            $btnClose = $("<button>");
            $screenOverlay = $("<div>");
            $wrapperLoading = $("<div>");

            //ajout des class CSS

            $panel.addClass("kzam_multiselect__panel");
            $wrapperContent.addClass("kzam_multiselect__wrapper_content");
            $buttonsWrapper.addClass("kzam_multiselect__wrapper_submit");
            $content.addClass("kzam_multiselect__content");
            $wrapper.addClass("kzam_multiselect__wrapper");
            $btnSubmit.addClass("kzam_multiselect__button");
            $btnClose.addClass("kzam_multiselect__button");
            $screenOverlay.addClass("kzam_multiselect__screen_overlay");
            $wrapperLoading.addClass("kzam_multiselect__wrapper_loading");


            $select.data("kzam_multiselect-name", $select.attr("name"));
            $input.attr("name", $select.attr("name"));
            $select.removeAttr("name");

            var nameInput = $input.attr("name").replace('[','').replace(']','');

            var idInput = nameInput + "_id";
            $input.attr("id", idInput);

            var attributes = $select.prop("attributes");
            $.each(attributes, function () {
                if (this.name !== "multiple" && this.name !== "id") {
                    $selectOut.attr(this.name, this.value);
                }
            });
            $("<option>").text(getTitle()).appendTo($select);
            $wrapper.css("width", $select.outerWidth() +"px");
            $select.find("option").last().remove();
            $selectOut.css("width", "100%"); //s'adapte obligatoirement au div parent
            $selectOut.addClass("kzam_multiselect__select");
            $select.addClass("kzam_multiselect__select_hidden");
            $selectOut.removeClass("kzam_multiselect__select_hidden");
            //insert
            $wrapper.insertAfter($select);
            $wrapper.append($selectOut);
            $wrapper.append($input);

            //construit l'affichage

            //met une option titre
            $selectOut.append("<option>" + getTitle() + "</option>");

            $panel.insertAfter($selectOut);
            $screenOverlay.insertBefore($panel);
            $panel.hide();


            //place la zone de contenu des checkboxs
            var lvl = 0;
            if (options["checkall"]) {
                $content.append(getHtmlCheckbox(0,1,lvl, idInput + '_all_check', nameInput + '_all_check', options["checkall_label"], "", false, "", true, true));
                lvl++;
            }


            $.each(datas, function (i, e) {

                var $wrapperGroup = $("<div>");
                $wrapperGroup.addClass("kzam_multiselect__checkbox_group");
                var isGroup = false;
                if (e.child.length > 0) {
                    isGroup = true;
                }

                if (e.value === "__(EMPTY)__") {
                    $wrapperGroup.append(getHtmlCheckbox(i,datas.length,lvl, idInput + '_' + i + '_check', nameInput + '_group_check', e.label, e.value, e.selected, e.disabled, e.css, isGroup, false));
                } else {
                    $wrapperGroup.append(getHtmlCheckbox(i,datas.length,lvl, idInput + '_' + i + '_check', nameInput + '_check', e.label, e.value, e.selected, e.disabled, e.css, isGroup, false));
                }

                if (e.child.length > 0) {

                    $.each(e.child, function (j, child) {
                        isGroup = false;
                        $wrapperGroup.append(getHtmlCheckbox(j,e.child.length,lvl + 1, idInput + '_' + i + '_' + j + '_check', nameInput + '_check', child.label, child.value, child.selected, child.disabled, child.css, isGroup, false));
                    });
                }
                $content.append($wrapperGroup);
            });
            $wrapperContent.append($content)
            $wrapperContent.css("overflow-y", "auto");

            if(options["class_content_wrapper"])$wrapperContent.addClass(options["class_content_wrapper"]);
            if(options["class_content"])$content.addClass(options["class_content"]);

            $panel.append($wrapperContent);
            if( option("display_close_button") === true || option("submit") === true )
            {
                $buttonsWrapper.append('<div class="kzam_multiselect__spacer-submit kzam_multiselect__spacer-submit-before">');
                if( option("display_close_button") === true )
                {
                    $btnClose.text(option("close_button_label"));
                    $btnSubmit.addClass("kzam_multiselect__btnClose");
                    if( option("close_button_class").length > 0 )
                    {
                        $btnClose.addClass(option("close_button_class"));
                    }
                    $buttonsWrapper.append($btnClose);
                }
                if( option("submit") === true )
                {
                    $btnSubmit.text(options["submit_label"]);
                    $btnSubmit.addClass("kzam_multiselect__btnSubmit");
                    if( option("submit_button_class").length > 0 )
                    {
                        $btnSubmit.addClass(option("submit_button_class"));
                    }
                    $buttonsWrapper.append($btnSubmit);
                }
                $buttonsWrapper.append('<div class="kzam_multiselect__spacer-submit kzam_multiselect__spacer-submit-after">');
                $buttonsWrapper.addClass("kzam_multiselect__wrapper-submit");

                $panel.append($buttonsWrapper);
            }

            let $loading_img = $("<img>").attr({
               "src": "css/images/ui/DualRing-1s-34px.gif",
                "alt": ""
            });
            let $loading_ul = $("<ul>"), $loading_li = $("<li>");
            $loading_img.appendTo($loading_li);
            $loading_li.appendTo($loading_ul);
            $loading_ul.appendTo($wrapperLoading);
            $wrapperLoading.addClass("d-none");
            $panel.prepend($wrapperLoading);


            $allCheckboxes = $wrapper.find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']");
            $btnCheckAll = $('#' + idInput + '_all_check');
            $btnCheckGroup = $wrapper.find("input[type='checkbox'][name='" + nameInput + "_group_check']");

            refreshCheckAllState(idInput);
            refreshCheckGroupState(idInput, nameInput);

            output();

            /**
             *  BIND ***************************************************************************************
             */

            /**
             *  mousedown sur le menu déroulant visible
             */
            $selectOut.on('mousedown', function (e) {
                e.preventDefault();

                if ($panel.attr("data-open") === true) {
                    $panel.hide();
                    $panel.attr("data-open", false);
                    funcOnClose();
                } else {
                    $panel.show();
                    $panel.attr("data-open", true);
                    //Marque le panel en cours comme le dernier ouvert
                    $('.kzam_multiselect__wrapper').attr("data-is-last-open", false);
                    $wrapper.attr("data-is-last-open", true);
                    resize();
                    funcOnOpen();
                }


            });

            /**
             *  mousedown n'importe ou sur le document
             */
            $(document).on("mousedown", function (e) {
                var $original_target = $(e.target);
                //todo : gérer le close en fonction pour déclencher le callback que sur un seul composant
                //ferme le menu si il ne s'agit pas d'un click sur le composant ou qu'il s'agit sd'un click sur le overlay mobil
                if ($original_target.parents('.kzam_multiselect__wrapper').length === 0 || $original_target.hasClass("kzam_multiselect__screen_overlay")) {
                    $panel.hide();
                    $panel.attr("data-open", false);
                    $wrapper.attr("data-is-last-open", false);
                    funcOnClose();

                } else {
                    //ferme le menu si il s'agit d'un click sur une autre instance du composant
                    $('.kzam_multiselect__wrapper[data-is-last-open!=true]').find('.kzam_multiselect__panel').attr("data-open", false).hide();

                }


            });

            /**
             * resize window
             */
            $(window).on("resize", function () {
                $panel.hide();
                $panel.attr("data-open", false);
                $wrapper.attr("data-is-last-open", false);
            });

            /**
             * Click sur la case à cocher CHECKALL
             */
            if ($btnCheckAll.length > 0) {
                $btnCheckAll.on('click', function () {

                    var $e = $(this);
                    if ($e.prop('checked')) {
                        $allCheckboxes.prop('checked', true);
                        $btnCheckGroup.prop('checked', true);
                        $btnCheckGroup.prop('indeterminate', false);
                    } else {
                        $allCheckboxes.prop('checked', false);
                        $btnCheckGroup.prop('checked', false);
                        $btnCheckGroup.prop('indeterminate', false);
                    }
                    output();
                });
            }

            /**
             * Click sur une case à cocher checkgroup
             */
            if ($btnCheckGroup.length > 0) {
                $btnCheckGroup.on('click', function (e) {
                    var $e = $(this);
                    if ($e.prop('checked')) {
                        $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']").prop('checked', true);
                    } else {
                        $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']").prop('checked', false);
                    }
                    if (options["submit"] === false) {
                        output();
                    }
                });
            }

            /**
             * Click sur une checkbox enfant
             */
            $allCheckboxes.on('change', function () {
                if (options["submit"] === false) {
                    output();
                }
                var $e = $(this);
                refreshCheckAllState(idInput);
                refreshTitle();

                //gestion de la case check du group
                var $btnCheckGroupParent = $e.parent().parent().parent().find("input[type='checkbox'][name='" + nameInput + "_group_check']");
                var $allCheckOfGroup = $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']");
                var $allCheckOfGroupChecked = $e.parent().parent().parent().find("input[type='checkbox'][id!='" + idInput + "_all_check'][name!='" + nameInput + "_group_check']:checked");
                if ($btnCheckGroupParent.length > 0) {
                    if ($allCheckOfGroup.length !== $allCheckOfGroupChecked.length && $allCheckOfGroupChecked.length > 0) {
                        $btnCheckGroupParent.prop("checked", true);
                        $btnCheckGroupParent.prop("indeterminate", true);
                    } else {
                        $btnCheckGroupParent.prop("indeterminate", false);
                        if ($allCheckOfGroupChecked.length === 0) {
                            $btnCheckGroupParent.prop("checked", false);
                        } else {
                            $btnCheckGroupParent.prop("checked", true);
                        }
                    }
                }

                funcOnChange.call(this, getValue());

            });



            /**
             * Click sur le bouton valider
             */
            if (options["submit"] === true) {
                $btnSubmit.on('click', function () {
                    output();
                    $panel.hide();
                    $panel.attr("data-open", false);
                    $wrapper.attr("data-is-last-open", false);
                    funcOnSubmit();
                });
            }

            if( option("display_close_button") === true )
            {
                $btnClose.on("click", () =>
                {
                   $panel.hide();
                    $panel.attr("data-open", false);
                    $wrapper.attr("data-is-last-open", false);
                    funcOnClose();
                });
            }

            funcOnRefresh();
            refreshTitle();
        }

        /**
         * Fonction qui redimenssionne le composant
         */
        function resize() {

            //place la fenêtre d'affichage
            $panel.width($selectOut.outerWidth() - 2);
            if (options["height"] !== "auto") {
                $panel.height(options["height"]);
            }

            //rafraichit la hauteur du bloc
           /* if (options["submit"] === true) {
                if (options["height"] !== "auto") {
                    $wrapperContent.height($panel.height() - $buttonsWrapper.outerHeight());
                }
            } else {
                $wrapperContent.height($panel.height());
            }*/

            //rafraichit la largeur des labels
            $panel.find(".kzam_multiselect__div").each(function (e, i) {
                var $e = $(this);

                // $e.find("label").width($panel.width() - parseInt($e.find("label").css("padding-left")) - parseInt($e.css("padding-left")) - parseInt(options["checkbox_width"]) - parseInt(options["scrollbar_width"]));
            });
        }

        /**
         * Générer la sortie sous forme de tableau dans le hidden
         */
        function output() {
            var outputLvl = [[], [], []];
            $input.val();

            $allCheckboxes.each(function (i, e) {
                let $e = $(this);
                if ($e.prop('checked') && $e.val() !== "__(EMPTY)__") {
                    outputLvl[parseInt($e.data("lvl"))].push($e.val());
                }
            });
            var outputObject = [[], []];
            if (outputLvl[0].length > 0) {
                outputObject[0] = outputLvl[0];
                if (outputLvl[1].length > 0) {
                    outputObject[1] = outputLvl[1];
                } else {
                    outputObject[1] = [];
                }
            } else {
                outputObject[0] = outputLvl[1];
                if (outputLvl[2].length > 0) {
                    outputObject[1] = outputLvl[2];
                } else {
                    outputObject[1] = [];
                }
            }
            //clean empty value
            for (var i = 0; i < outputObject[0].length; i++) {
                if (outputObject[0][i] === "") {
                    outputObject[0].splice(i, 1);
                    i--;
                }
            }
            for ( i = 0; i < outputObject[1].length; i++) {
                if (outputObject[1][i] === "") {
                    outputObject[1].splice(i, 1);
                    i--;
                }
            }
            if (options["merge-output"]) {
                outputObject = $.merge(outputObject[0], outputObject[1]);
            }
            $input.val(JSON.stringify(outputObject));
            $input.trigger("change");

        }

        function reset() {
            $allCheckboxes.each(function (i, e) {
                let $e = $(this);
                $e.prop('checked', false).trigger("change");

            });
        }

        function setLoading(bLoading)
        {
            if( bLoading )
            {
                $wrapperLoading.removeClass("d-none");
            }
            else
            {
                $wrapperLoading.addClass("d-none");
            }
        }

        function getWrapper() {
            return $wrapper;
        }

        /**
         * Générer le bloc HTML correspondant à une checkbox
         * @param index_item index de la case à cocher
         * @param nb_item nombre de case à cocher dans au même niveau
         * @param lvl niveau de decallage
         * @param id
         * @param name
         * @param label
         * @param value
         * @param is_checked
         * @param is_disabled
         * @param custom_css
         * @param is_group
         * @param is_checkall
         * @returns {*|HTMLElement}
         */
        function getHtmlCheckbox(index_item,nb_item,lvl, id, name, label, value, is_checked, is_disabled, custom_css, is_group, is_checkall) {


            var $div = $('<div>');
            var $span = $('<span>');
            var $text = $('<span>');
            var $checkbox = $('<input type="checkbox">');
            var $label = $('<label>');

            //attribut
            $checkbox.attr("name", name);
            $checkbox.attr("id", id);
            $checkbox.attr("value", value);
            $checkbox.attr("data-lvl", lvl);
            $div.attr("data-lvl", lvl);

            $label.attr("for", $checkbox.attr("id"));

            $label.attr("title", label);

            if (is_checked) {
                $checkbox.prop("checked", true);
            }

            if( is_disabled )
            {
                $checkbox.prop("disabled", true);
                $text.css("opacity", 0.6);
            }

            //ajout des class css
            $div.addClass("kzam_multiselect__div");
            $span.addClass("kzam_multiselect__span");
            $checkbox.addClass("kzam_multiselect__checkbox");
            $label.addClass("kzam_multiselect__label");
            $text.addClass("kzam_multiselect__label-text");
            if (is_checkall) {
                $text.addClass("kzam_multiselect__label-checkall");
            }
            if (is_group) {
                $text.addClass("kzam_multiselect__label-group");
            }

            $div.addClass("kzam_multiselect__" + lvl);

            $checkbox.addClass("kzam_multiselect__" + lvl);
            $label.addClass("kzam_multiselect__" + lvl);
            $span.addClass("kzam_multiselect__" + lvl);
            if(index_item===nb_item-1){
                $div.addClass("kzam_multiselect__last-item");
            }
            if(index_item===0){
                $div.addClass("kzam_multiselect__first-item");
            }


            if (typeof custom_css !== typeof undefined && custom_css !== false) {

                $text.addClass(custom_css);
            }

            //dom
            $text.html(label);
            $label.append($checkbox);
            $label.append($span);
            $label.append($text);
            $div.append($label);


            return $div;
        }


        /**
         * Retourne / modifie une option
         * @param key
         * @param val
         * @returns {*}
         */
        function option(key, val) {
            if (val) {
                options[key] = val;
            } else {
                return options[key];
            }
        }

        /**
         * set callback function to call on Open panel
         * @param func
         */
        function setCallbackOpen(func){
            funcOnOpen=func;
        }
        /**
         * set callback function to call on Hide panel
         * @param func
         */
        function setCallbackClose(func){
            funcOnClose=func;
        }

        /**
         * set callback function to call on click submit
         * @param func
         */
        function setCallbackSubmit(func){
            funcOnSubmit=func;
        }

        function setCallbackChange(func)
        {
            funcOnChange = func;
        }

        /**
         * set callback function to call on Refresh panel
         * @param func
         */
        function setCallBackRefresh(func){
            funcOnRefresh=func;
        }

        init();

        /**
         * Méthodes publiques
         */
        return {
            "option": option,
            "refresh": refresh,
            "restore": restore,
            "parse" : parseData,
            "onOpen" : setCallbackOpen,
            "onClose" : setCallbackClose,
            "onRefresh": setCallBackRefresh,
            "onSubmit" : setCallbackSubmit,
            "onChange": setCallbackChange,
            "getValue": getValue,
            "getValuesMap": getValuesMap,
            "getUncheckedValues": getUncheckedValues,
            "reset": reset,
            "refreshTitle": refreshTitle,
            "getWrapper": getWrapper,
            "setLoading": setLoading
        };

    }

    /**
     * Gestion du plugin JQUERY
     * @param options
     * @returns {*}
     * @constructor
     */
    $.fn[pluginName] = function (options) {
        if (arguments[0] === 'this') {
            return this;
        } else {

        }
        if (typeof arguments[0] === 'string') {
            var methodName = arguments[0];
            var args = Array.prototype.slice.call(arguments, 1);
            var returnVal;
            this.each(function () {
                if ($.data(this, 'plugin_' + pluginName) && typeof $.data(this, 'plugin_' + pluginName)[methodName] === 'function') {
                    returnVal = $.data(this, 'plugin_' + pluginName)[methodName].apply(this, args);
                } else {
                    throw new Error('Method ' + methodName + ' does not exist on jQuery.' + pluginName);
                }
            });
            if (returnVal !== undefined) {
                return returnVal;
            } else {
                return this;
            }
        } else if (typeof options === "object" || !options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
                }
            });
        }
    };

    /**
     * Liste des options avec leur valeur par défaut
     */
    $.fn[pluginName].defaults = {
        "title": "Choisir ...",
        "display_count_in_title": false,
        "checkall": true,
        "checkall_label": "Tous",
        "merge-output": true,
        "submit": false,
        "submit_label": "Valider",
        "height": "auto",
        "scrollbar_width": 16,
        "checkbox_width": 25,
        "class_content_wrapper" :"",
        "class_content":"",
        "submit_button_class": "",
        "close_button_class": "",
        "display_close_button": true,
        "close_button_label": "Fermer"
    };

})(jQuery);